module.exports = __webpack_public_path__ + "media/images/icons/download-38226004395f84b8ec34f91c477c3707.svg";